import React from 'react';
import { NextPage } from 'next';

import { domofonAction } from '@r1-frontend/api-domru/api-content/v1/domofon-action';
import { TResponseDto } from '@r1-frontend/api-domru/api-content/v1/domofon-action/dto/ResponseDto';
import { IPpdPricesDto } from '@r1-frontend/api-domru/ppd-service/dto/IPpdPricesDto';
import { getPpdPrices } from '@r1-frontend/api-domru/ppd-service/v1/ppd-prices';
import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import Layout from '~/src/features/_layout';
import Center from '~/src/features/center';
import { getPageDataSeo } from '~/src/features/center/utils';
import { initialProps } from '~/src/helpers/basePageFunc';
import getRequester from '~/src/helpers/getRequester';
import { saveIntercomAction } from '~/src/store/actions/intercom';

interface IProps {
    city: ICurrentCity,
    pageDataSeo: ReturnType<typeof getPageDataSeo>,
    dataPrices: IPpdPricesDto[] | [],
}

const ServiceCenterPage: NextPage<IProps> = ({ city, pageDataSeo, dataPrices }) => {
    return (
        <Layout
            title={pageDataSeo.title}
            description={pageDataSeo.description}
            withMenu={false}
            withChat={false}
            withFooter={false}
        >
            <Center
                city={city}
                dataPrices={dataPrices}
            />
        </Layout>
    );
};

ServiceCenterPage.getInitialProps = async(options) => {
    await initialProps(options, { isNeedAuthData: true });
    const { req, store } = options;
    const { city: { currentCity: city, provider: { providerId } } } = store.getState();
    const pageDataSeo = getPageDataSeo(city);
    const doRequest = getRequester(req);

    const [dataPricesResp, domofon] = await Promise.all([
        doRequest.ppdService<IPpdPricesDto[]>(getPpdPrices(providerId)),
        doRequest.apiContent<TResponseDto>(domofonAction({ filter: { available: 1 } })),
    ]);
    const dataPrices = dataPricesResp.isSuccess ? dataPricesResp.payload : [];

    if (domofon.isSuccess && domofon.payload.items.length > 0) {
        // берем первую доступную акцию для текущего города
        store.dispatch(saveIntercomAction(domofon.payload.items[0]));
    }

    return ({
        city,
        pageDataSeo,
        dataPrices: dataPrices,
    });
};

export default ServiceCenterPage;
